// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__s0GAk"};